import { inject, provide, type App } from 'vue'

export type SiteFeatures = Partial<{
  extendedPlan: boolean

  /**
   * When set, "Search Flight" redirects to this URL instead of searching
   */
  redirectUrl: string
}>

const getWithDefaultFeatures = (features: SiteFeatures = {}) => {
  const { extendedPlan = false, redirectUrl } = features
  return { extendedPlan, redirectUrl }
}

const KEY = Symbol('site-features')

export const useSiteFeatures = (features: SiteFeatures = {}) => {
  const siteFeatures = getWithDefaultFeatures(features)
  return inject(KEY, siteFeatures)
}

useSiteFeatures.provide = (features: SiteFeatures, app?: App) => {
  const siteFeatures = getWithDefaultFeatures(features)
  app ? app.provide(KEY, siteFeatures) : provide(KEY, siteFeatures)
}